import { createApp } from 'vue'
import App from './App.vue'
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import PrimeVue from 'primevue/config';
import router from "./router/route.js";
import i18n from './plugins/i18n';
import { createPinia } from 'pinia'

// import VueTelInput from 'vue3-tel-input';
// import 'vue3-tel-input/dist/vue3-tel-input.css';

// import vue3GoogleLogin from 'vue3-google-login';
// import AppleAuth from './plugins/appleAuth';
// import FacebookAuth from './plugins/facebookAuth';
import { createHead } from '@vueuse/head'
// import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil";

// import './registerServiceWorker'
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Service worker unregistered');
    }
  }).catch(error => {
    console.error('Error during service worker unregistering:', error);
  });
}
const isLocalhost = window.location.hostname === 'localhost';
if (!isLocalhost) {
  Object.keys(console).forEach(method => {
    console[method] = function () {};
  });
}
loadFonts();
const head = createHead()
const pinia = createPinia()

createApp(App)
.use(router)
.use(head)
.use(vuetify)
.use(PrimeVue)
.use(i18n)
.use(pinia)
// .use(VueTelInput)
// .use(vue3GoogleLogin, {
//     clientId: 'YOUR_GOOGLE_CLIENT_ID'
// })
// .use(AppleAuth, {
//     clientId: 'com.yourapp.identifier',
//     redirectUri: 'https://yourapp.com/callback',
// })
// .use(FacebookAuth, {
//     clientId: 'your-facebook-app-id',
//     redirectUri: 'https://yourapp.com/callback',
//   })
.mount('#app')